import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();



// Register the service worker
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Show update notification when new content is available
    if (window.confirm('A new version is available! Refresh to update?')) {
      // Listen for when the new service worker takes control
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // Reload the page when the new service worker takes control
        window.location.reload();
      });
      
      // Tell the waiting service worker to skip waiting and activate immediately
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    }
  },
  onSuccess: (registration) => {
    console.log('Service worker registered successfully');
  }
});
